import { ARTICLE_TIME_ZONE } from '@ahora-patagonia/contracts';

/**
 * Fechas SIEMPRE en la zona del medio y con locale fijo: si el server formatea en UTC y el
 * browser en la zona del lector, el texto difiere y React lo reporta como hydration mismatch.
 * `es-AR` + `America/Argentina/Buenos_Aires` en los dos lados, sin excepción.
 */

const FECHA = new Intl.DateTimeFormat('es-AR', {
  timeZone: ARTICLE_TIME_ZONE,
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});

const FECHA_Y_HORA = new Intl.DateTimeFormat('es-AR', {
  timeZone: ARTICLE_TIME_ZONE,
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const HORA = new Intl.DateTimeFormat('es-AR', {
  timeZone: ARTICLE_TIME_ZONE,
  hour: '2-digit',
  minute: '2-digit',
});

/** "30 de julio de 2026" */
export function formatearFecha(iso: string): string {
  return FECHA.format(new Date(iso));
}

/** "30 de julio de 2026, 12:05" — la de la firma de la nota (`publishedAt`, no la edición). */
export function formatearFechaYHora(iso: string): string {
  return FECHA_Y_HORA.format(new Date(iso));
}

/** "12:05" — la de la tira de Última hora. */
export function formatearHora(iso: string): string {
  return HORA.format(new Date(iso));
}
